import React, { useId, useState } from "react";
import { Input } from "reactstrap";

import { KeyNames } from "@utils/enums";
import { createKeyHandler } from "@utils/keyboard";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./storeLocatorMobile.scss";

type Props = {
    link: string;
};

const StoreLocatorMobile = ({ link }: Props) => {
    const { t } = useGranite();
    const storeInputId = useId();
    const [location, setLocation] = useState("");

    const clickHandler = () => {
        const queryParams = new URLSearchParams(window.location.search);

        queryParams.set("textualLocation", location);
        window.location.assign(`${link}?${queryParams.toString()}`);
    };

    const handleOnInputKeyDown = createKeyHandler([
        {
            keys: [KeyNames.ENTER],
            handler: clickHandler,
        },
    ]);

    return (
        <div className="store-locator-mobile">
            <h2>{t("storelocator.mobile.title")}</h2>
            <label htmlFor={storeInputId}>
                {t("storelocator.mobile.description")}
            </label>
            <Input
                id={storeInputId}
                value={location}
                placeholder={t("form.searchstore.input.placeholder")}
                name="textualLocation"
                onChange={({ target: { value } }: any) => setLocation(value)}
                onKeyDown={handleOnInputKeyDown}
            />
            <p
                className="btn btn-block mt-2 store-locator-mobile-submit"
                onClick={clickHandler}
            >
                {t("storelocator.mobile.submit")}{" "}
                <i className="la-md las la-angle-right"></i>
            </p>
        </div>
    );
};

export default StoreLocatorMobile;
